'use client';

export { TiptapEditor } from '@agentteams/runner-request/ui/components/TiptapEditor';
